import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cookie-banner__content" }
const _hoisted_2 = { class: "cookie-banner__text text-body-2" }
const _hoisted_3 = { class: "cookie-banner__controls" }
const _hoisted_4 = { class: "toggles" }
const _hoisted_5 = { class: "actions" }

import { computed, ref } from "vue";
import GlobalService from "@/services/global-service";
import { useConsentStore } from "@/stores/consent";


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieConsentBanner',
  setup(__props) {

const t = (key: string) => GlobalService.translator().trans(key);

const store = useConsentStore();
const needsBanner = computed(() => store.needsBanner);
const analytics = ref<boolean>(!!store.categories.analytics);
const marketing = ref<boolean>(!!store.categories.marketing);

function acceptAll() { store.acceptAll(); }
function acceptSelected() { store.saveChoices({ analytics: analytics.value, marketing: marketing.value }); }
function acceptEssential() { store.allowEssentialOnly(); }

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!

  return (_openBlock(), _createBlock(_component_v_slide_y_transition, null, {
    default: _withCtx(() => [
      (needsBanner.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "cookie-banner",
            elevation: "10",
            rounded: "xl",
            color: "surface",
            role: "region",
            "aria-label": t('cookies.aria_label')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(t("cookies.banner_text")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_chip, {
                    size: "small",
                    variant: "tonal",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t("cookies.essential_required")), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_switch, {
                      inset: "",
                      "hide-details": "",
                      color: "primary",
                      modelValue: analytics.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((analytics).value = $event)),
                      label: t('cookies.analytics')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_v_switch, {
                      inset: "",
                      "hide-details": "",
                      color: "primary",
                      modelValue: marketing.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((marketing).value = $event)),
                      label: t('cookies.marketing')
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      variant: "text",
                      onClick: acceptEssential,
                      class: "text-none"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(t("cookies.allow_essential_only")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      color: "primary",
                      variant: "tonal",
                      onClick: acceptSelected,
                      class: "text-none"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(t("cookies.save_choices")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      color: "primary",
                      onClick: acceptAll,
                      class: "text-none"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(t("cookies.accept_all")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})